export const CONTACT = {
    email: "harshad@hvpconsultants.com",
    whatsapp: "https://wa.me/918104584662?text=Hi%20Harshad%20—%20let's%20talk%20marketing.",
    phone: "+91 81045 84662",
    socials: [
        { label: "Instagram", href: "https://instagram.com/hvp_consultancy" },
    ],
};

export const SERVICES = [
    {
        num: "01",
        title: "Media Planning & Buying",
        desc: "Sharp plans and real buying power across out-of-home, print, broadcast and digital inventory. Every unit of spend accounted for, every placement negotiated to the edge.",
        image:
            "https://images.unsplash.com/photo-1635873432087-50eba4c4392d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        num: "02",
        title: "Digital Marketing",
        desc: "Search, programmatic, email and funnels engineered as one system — brand at the top, performance at the bottom, no dead air in between.",
        image:
            "https://images.unsplash.com/photo-1742046335792-060080d72460?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        num: "03",
        title: "Social Media",
        desc: "Always-on content, creator collabs and community management that turn followers into believers and comment sections into converts.",
        image:
            "https://images.pexels.com/photos/8694329/pexels-photo-8694329.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
        num: "04",
        title: "PR & Communications",
        desc: "Stories editors actually want. Press offices, launches, crisis counsel and a reputation that compounds long after the campaign ends.",
        image:
            "https://images.unsplash.com/photo-1498644035638-2c3357894b10?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    },
    {
        num: "05",
        title: "Business Consultation",
        desc: "Strategy beyond the feed — positioning, go-to-market and growth roadmaps that give every campaign a business case.",
        image:
            "https://images.pexels.com/photos/7964184/pexels-photo-7964184.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
    {
        num: "06",
        title: "DAAS — Data As A Service",
        desc: "Dashboards, attribution and audience insight, served like infrastructure — your numbers turned into decisions.",
        image:
            "https://images.pexels.com/photos/27141316/pexels-photo-27141316.jpeg?auto=compress&cs=tinysrgb&w=1200",
    },
];

export const FOUNDER_QUOTE = {
    quote:
        "Calm in a crisis, relentless in a campaign. Our press coverage went from complaints to covers.",
    name: "Founder — Harshad Patil",
    role: "HVP Consultants",
};

export const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.3 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
